import { Link } from "react-router-dom";
import PublicFooter from "@/components/PublicFooter";

function LegalShell({ title, children, testid }) {
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50" data-testid={testid}>
      <header className="border-b border-neutral-200 bg-white">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center gap-3">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-lg bg-emerald-500 flex items-center justify-center font-display font-bold text-neutral-900 text-sm">AC</div>
            <span className="font-display text-base font-semibold">AgencyCash</span>
          </Link>
        </div>
      </header>
      <main className="flex-1">
        <article className="max-w-3xl mx-auto px-6 py-12">
          <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight mb-6">{title}</h1>
          <div className="prose prose-neutral max-w-none text-neutral-700 leading-relaxed space-y-4">
            {children}
          </div>
        </article>
      </main>
      <PublicFooter />
    </div>
  );
}

export function ImpressumPage() {
  return (
    <LegalShell title="Impressum" testid="impressum-page">
      <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm">
        <strong>Hinweis:</strong> Dieses Impressum wird in Kürze final ergänzt. Bei Fragen melde dich unter <a href="mailto:hello@agency-cash.app" className="underline">hello@agency-cash.app</a>.
      </div>
      <h2 className="font-display text-xl font-semibold pt-4">Angaben gemäß § 5 TMG</h2>
      <p>
        AgencyCash<br/>
        [Firmenname, Anschrift, PLZ Ort]<br/>
        Deutschland
      </p>
      <h2 className="font-display text-xl font-semibold pt-4">Kontakt</h2>
      <p>
        E-Mail: <a href="mailto:hello@agency-cash.app" className="underline">hello@agency-cash.app</a>
      </p>
      <h2 className="font-display text-xl font-semibold pt-4">Vertretungsberechtigte Person</h2>
      <p>Kristian Buller</p>
      <h2 className="font-display text-xl font-semibold pt-4">Umsatzsteuer-ID</h2>
      <p>Wird ergänzt.</p>
      <h2 className="font-display text-xl font-semibold pt-4">Verantwortlich für den Inhalt</h2>
      <p>Kristian Buller — Anschrift wie oben.</p>
      <h2 className="font-display text-xl font-semibold pt-4">Streitschlichtung</h2>
      <p>
        Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a href="https://ec.europa.eu/consumers/odr/" className="underline" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a>.
        Wir sind nicht bereit oder verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </LegalShell>
  );
}

export function DatenschutzPage() {
  return (
    <LegalShell title="Datenschutzerklärung" testid="datenschutz-page">
      <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm">
        <strong>Hinweis:</strong> Diese Datenschutzerklärung wird in Kürze final ergänzt. Für Auskunfts-, Lösch- oder Berichtigungsanfragen melde dich unter <a href="mailto:hello@agency-cash.app" className="underline">hello@agency-cash.app</a>.
      </div>
      <h2 className="font-display text-xl font-semibold pt-4">1. Datenschutz auf einen Blick</h2>
      <p>
        Diese Datenschutzerklärung klärt dich über Art, Umfang und Zweck der Verarbeitung personenbezogener Daten innerhalb von AgencyCash auf.
      </p>
      <h2 className="font-display text-xl font-semibold pt-4">2. Verantwortliche Stelle</h2>
      <p>Kristian Buller · <a href="mailto:hello@agency-cash.app" className="underline">hello@agency-cash.app</a></p>
      <h2 className="font-display text-xl font-semibold pt-4">3. Welche Daten verarbeiten wir?</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>Account-Daten: Name, E-Mail, Firmenname, gehashtes Passwort (bcrypt).</li>
        <li>Finanzdaten, die du selbst erfasst: Konten, Rechnungen, Kunden, Projekte, Fixkosten.</li>
        <li>Technische Daten: IP-Adresse, Browser, Zugriffslogs (zum Schutz vor Missbrauch).</li>
      </ul>
      <h2 className="font-display text-xl font-semibold pt-4">4. Wo werden deine Daten gespeichert?</h2>
      <p>Deine Daten werden in einer MongoDB-Datenbank innerhalb der EU gespeichert. Jeder Tenant (Agentur) ist strikt isoliert.</p>
      <h2 className="font-display text-xl font-semibold pt-4">5. Auftragsverarbeiter</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li><strong>Resend</strong> (E-Mail-Versand) — EU-Region.</li>
        <li><strong>OpenAI</strong> (GPT-5.2, nur für OCR von hochgeladenen Rechnungen — keine Trainingsnutzung).</li>
        <li><strong>Hosting-Provider</strong> wird ergänzt.</li>
      </ul>
      <h2 className="font-display text-xl font-semibold pt-4">6. Deine Rechte</h2>
      <p>Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Datenübertragbarkeit nach DSGVO.</p>
    </LegalShell>
  );
}

export function AgbPage() {
  return (
    <LegalShell title="Allgemeine Geschäftsbedingungen" testid="agb-page">
      <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm">
        <strong>Hinweis:</strong> Diese AGB sind in der Beta-Phase. Wir benachrichtigen dich rechtzeitig, falls sich rechtliche Rahmenbedingungen ändern.
      </div>
      <h2 className="font-display text-xl font-semibold pt-4">§ 1 Geltungsbereich</h2>
      <p>Diese AGB gelten für die Nutzung von AgencyCash (im Folgenden „die App") durch dich („Nutzer").</p>
      <h2 className="font-display text-xl font-semibold pt-4">§ 2 Leistungsumfang</h2>
      <p>AgencyCash stellt ein mandantenfähiges Finanz-Cockpit für Agenturen und Dienstleister bereit. Die App rechnet auf Basis der vom Nutzer eingegebenen Daten — sie ersetzt keinen Steuerberater.</p>
      <h2 className="font-display text-xl font-semibold pt-4">§ 3 Beta-Phase</h2>
      <p>Während der Beta-Phase ist die Nutzung kostenfrei. Wir behalten uns vor, Funktionen anzupassen oder neue Tarife einzuführen — du erhältst rechtzeitig Bescheid.</p>
      <h2 className="font-display text-xl font-semibold pt-4">§ 4 Haftung</h2>
      <p>Die App wird mit Sorgfalt entwickelt. Eine Haftung für mittelbare Schäden, entgangenen Gewinn oder Datenverlust ist ausgeschlossen, soweit gesetzlich zulässig. Der Nutzer ist verpflichtet, eigene Backups seiner Daten anzulegen.</p>
      <h2 className="font-display text-xl font-semibold pt-4">§ 5 Vertraulichkeit / Datenschutz</h2>
      <p>Es gilt unsere <Link to="/datenschutz" className="underline">Datenschutzerklärung</Link>. Daten verschiedener Tenants werden strikt isoliert verarbeitet.</p>
      <h2 className="font-display text-xl font-semibold pt-4">§ 6 Kündigung / Account-Löschung</h2>
      <p>Du kannst deinen Account jederzeit löschen lassen — schreib uns dazu kurz an hello@agency-cash.app.</p>
      <h2 className="font-display text-xl font-semibold pt-4">§ 7 Gerichtsstand</h2>
      <p>Es gilt deutsches Recht. Gerichtsstand ist — soweit gesetzlich zulässig — der Sitz des Anbieters.</p>
    </LegalShell>
  );
}
